module.exports = __webpack_public_path__ + "img/img11.6a5e4819.svg";